import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "violet"
}
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = {
  href: '/competitions',
  class: "text-sm text-blue-700 hover:text-blue-900 mb-6 inline-block"
}
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_5 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_6 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800" }
const _hoisted_7 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-blue-50 text-blue-700" }
const _hoisted_8 = {
  key: 0,
  class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-green-100 text-green-800"
}
const _hoisted_9 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-2xl font-bold text-gray-900 mb-4" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-wrap gap-2 mb-4"
}
const _hoisted_13 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_14 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_15 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 mr-2" }
const _hoisted_16 = {
  key: 3,
  class: "mb-4"
}
const _hoisted_17 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800" }
const _hoisted_18 = {
  key: 4,
  class: "text-gray-600 mb-6 whitespace-pre-line"
}
const _hoisted_19 = {
  key: 5,
  class: "flex flex-wrap gap-2 mb-6"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 6,
  class: "rounded-lg border border-gray-200 overflow-hidden map-container mb-6"
}
const _hoisted_23 = {
  ref: "mapContainer",
  style: {"height":"300px","width":"100%"}
}
const _hoisted_24 = {
  key: 7,
  class: "flex gap-3 mt-4"
}
const _hoisted_25 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "competitions"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, "← " + _toDisplayString($setup.t('competitions.back_to_list')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString($setup.formatDate($setup.comp.date)), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_7, _toDisplayString($setup.formatTime($setup.comp.date)), 1 /* TEXT */),
          ($setup.comp.running_type)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.t('competitions.type_' + $setup.comp.running_type)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        ($setup.comp.logo_url)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                src: $setup.comp.logo_url,
                class: "w-full rounded-lg object-contain border border-gray-200"
              }, null, 8 /* PROPS */, _hoisted_10)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("h1", _hoisted_11, _toDisplayString($setup.comp.name), 1 /* TEXT */),
        ($setup.comp.distances && $setup.comp.distances.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.comp.distances, (d) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: d.id,
                  class: "inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-sm font-medium bg-gray-100 text-gray-700"
                }, [
                  _createTextVNode(_toDisplayString(d.km) + " km ", 1 /* TEXT */),
                  (d.elevation_gain)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "↑" + _toDisplayString(d.elevation_gain) + "m", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.comp.pending && $props.userAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString($setup.t('competitions.pending')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.approveCompetition,
                class: "px-4 py-1.5 text-sm font-medium text-green-700 bg-green-50 rounded-lg hover:bg-green-100 transition"
              }, _toDisplayString($setup.t('competitions.approve')), 1 /* TEXT */)
            ]))
          : ($setup.comp.pending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString($setup.t('competitions.pending')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
        ($setup.comp.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString($setup.comp.description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($setup.comp.link || $setup.comp.results_link)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              ($setup.comp.link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: $setup.comp.link,
                    target: "_blank",
                    class: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition"
                  }, [
                    _createTextVNode(_toDisplayString($setup.t('competitions.visit_link')) + " ", 1 /* TEXT */),
                    _cache[0] || (_cache[0] = _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      })
                    ], -1 /* CACHED */))
                  ], 8 /* PROPS */, _hoisted_20))
                : _createCommentVNode("v-if", true),
              ($setup.comp.results_link)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: $setup.comp.results_link,
                    target: "_blank",
                    class: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-green-700 rounded-lg hover:bg-green-800 transition"
                  }, [
                    _createTextVNode(_toDisplayString($setup.t('competitions.results')) + " ", 1 /* TEXT */),
                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 17v-6m4 6V7m4 10v-3M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"
                      })
                    ], -1 /* CACHED */))
                  ], 8 /* PROPS */, _hoisted_21))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.comp.latitude && $setup.comp.longitude)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, null, 512 /* NEED_PATCH */)
            ]))
          : _createCommentVNode("v-if", true),
        ($props.userAdmin || $setup.comp.user_id === $props.userId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("a", {
                href: `/competitions?edit=${$setup.comp.id}`,
                class: "px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
              }, _toDisplayString($setup.t('competitions.edit')), 9 /* TEXT, PROPS */, _hoisted_25),
              _createElementVNode("button", {
                onClick: $setup.deleteCompetition,
                class: "px-4 py-2 text-sm font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
              }, _toDisplayString($setup.t('competitions.delete')), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}